<template>
  <CockpitCard
    :title="'进度模拟'"
    left="170px"
    width="1600px"
    height="700px"
    top="174px"
    cardType="horizontal"
    @close="close"
  >
    <div class="mt-10px">
      <el-select
        v-model="currentPlanId"
        placeholder="请选择"
        class="w-full"
        popper-class="visualization-select-popper"
        :popper-append-to-body="false"
        filterable
        :disabled="!modelLoaded"
        @change="changePlan"
      >
        <el-option
          v-for="item in planList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>
    <div class="flex justify-start items-start mb-10px mt-10px">
      <img src="../../../assets/images/titleIcon.png" alt />
      <span class="text-14px text-white ml-4px">{{ planStartDate }} ~ {{ planFinishDate }}</span>
    </div>
    <el-row :gutter="10">
      <el-col :span="18" :offset="0">
        <el-date-picker
          size="small"
          :disabled="!planStartDate"
          popper-class="visualization-picker-popper"
          class="!w-full visual_input"
          v-model="checkDate"
          :picker-options="datePickOption"
          type="date"
          placeholder="查看日期"
          @change="handleCheck"
        ></el-date-picker>
      </el-col>
      <el-col :span="6" :offset="0">
        <el-button
          type="primary"
          :loading="loadProgress"
          size="small"
          :disabled="!planStartDate"
          class="ml-10px btn-example"
          @click="checkDate ? playByCheckDate(dayjs(checkDate).diff(planStartDate, 'day')) : ''"
          >播放</el-button
        >
      </el-col>
    </el-row>
    <div
      class="w-full h-36px mt-10px mb-10px border border-solid border-hex-03ffec text-hex-03ffec rounded-4px text-14px p-10px font-bold"
    >
      {{ currentDate }}
    </div>
    <!-- 施工中 -->
    <el-row class="flex items-center justify-center mt-10px h-90px max_label">
      <el-col :span="3" :offset="0" class="h-full flex items-center justify-center">
        <span class="write-vertical-left text-14px text-white tracking-3px ">施工中</span>
      </el-col>
      <el-col :span="7" :offset="0" class="text-center h-full">
        <div class="text-28px h-60px !leading-60px" :style="{ color: progressMap['workAsPlan'] }">
          {{ currentDateStatistics['workAsPlanCount'] || 0 }}
        </div>
        <div class="text-14px h-30px !leading-30px text-white">按计划施工</div>
      </el-col>
      <el-col :span="7" :offset="0" class="text-center h-full">
        <div
          class="text-28px h-60px !leading-60px"
          :style="{ color: progressMap['workDelayPlan'] }"
        >
          {{ currentDateStatistics['workDelayPlanCount'] || 0 }}
        </div>
        <div class="text-14px text-white h-30px !leading-30px">落后计划开始</div>
      </el-col>
      <el-col :span="7" :offset="0" class="text-center h-full">
        <div
          class="text-28px h-60px !leading-60px"
          :style="{ color: progressMap['workDelayDone'] }"
        >
          {{ currentDateStatistics['workDelayDoneCount'] || 0 }}
        </div>
        <div class="text-14px text-white h-30px !leading-30px">落后计划结束</div>
      </el-col>
    </el-row>
    <el-row class="flex mt-10px items-center justify-center h-90px max_label">
      <el-col :span="3" :offset="0" class="h-full flex items-center justify-center">
        <span class="write-vertical-left text-14px text-white tracking-3px">未开始</span>
      </el-col>
      <el-col :span="7" :offset="0" class="text-center">
        <div
          class="text-28px h-60px !leading-60px"
          :style="{ color: progressMap['delayPlanStart'] }"
        >
          {{ currentDateStatistics['delayPlanStartCount'] || 0 }}
        </div>
        <div class="text-14px text-white h-30px !leading-30px">落后计划开始</div>
      </el-col>
      <el-col :span="7" :offset="0" class="text-center">
        <div class="text-28px h-60px !leading-60px" :style="{ color: progressMap['noWork'] }">
          {{ currentDateStatistics['noWorkCount'] || 0 }}
        </div>
        <div class="text-14px text-white h-30px !leading-30px">按计划未施工</div>
      </el-col>
      <el-col :span="7" :offset="0" class="text-center"> </el-col>
    </el-row>
    <el-row class="flex items-center mt-10px justify-center h-90px">
      <el-col :span="11" :offset="0" class="h-full min_label">
        <el-col :span="6" :offset="0" class="h-full flex items-center justify-center">
          <span class="write-vertical-left text-14px text-white tracking-3px">已完成</span>
        </el-col>
        <el-col :span="18" :offset="0" class="text-center align-middle">
          <div
            class="text-28px h-60px !leading-60px"
            :style="{ color: progressMap['alreadyDone'] }"
          >
            {{ currentDateStatistics['alreadyDoneCount'] || 0 }}
          </div>
          <div class="text-14px text-white h-30px !leading-30px">已完成施工</div>
        </el-col>
      </el-col>
      <el-col :span="11" :offset="2" class="h-full min_label">
        <el-col :span="6" :offset="0" class="h-full flex items-center justify-center">
          <span class="write-vertical-left text-14px text-white tracking-3px">不在范围</span>
        </el-col>
        <el-col :span="18" :offset="0" class="text-center">
          <div class="text-28px h-60px !leading-60px" :style="{ color: progressMap['notInRange'] }">
            {{ currentDateStatistics['notInRangeCount'] || 0 }}
          </div>
          <div class="text-14px text-white h-30px !leading-30px">不在计划范围内</div>
        </el-col>
      </el-col>
    </el-row>
    <div class="flex justify-start items-start mb-10px mt-10px">
      <img src="../../../assets/images/titleIcon.png" alt />
      <span class="text-16px text-white ml-4px">今日任务</span>
    </div>
    <!-- 任务列表 -->
    <el-row :gutter="20" class="h-90px overflow-y-auto overflow-x-hidden">
      <el-col
        :span="12"
        :offset="0"
        class="text-white text-14px h-30px cursor-pointer"
        v-for="(item, index) in currentDateStatistics.toDayActivities || []"
        :key="index"
      >
        <el-tooltip :content="item.name" placement="top" effect="dark">
          <span @click="viewTaskDetail(item.id)"> {{ item.name }}</span>
        </el-tooltip>
      </el-col>
    </el-row>
    <!-- 进度条 -->
    <div class="w-full h-80px">
      <el-slider
        class="mx-10px"
        :disabled="btnLoading"
        @change="sliderChanged"
        :show-tooltip="false"
        :min="0"
        :max="sliderMaxLenngth"
        v-model="sliderData"
      ></el-slider>
      <el-row :gutter="20" :disabled="playStatus === 'pending'">
        <el-col :span="12" :offset="0" class="flex items-center">
          <span class="text-hex-9CACAC text-18px mr-10px">调速</span>
          <span
            class="speed flex items-center justify-center text-white text-18px w-50px h-36px cursor-pointer bg-[#244C50]"
            >{{ speed }}x</span
          >
        </el-col>
        <el-col :span="12" :offset="0" class="flex">
          <el-tooltip effect="dark" :content="`${$t('慢放')}`" placement="top">
            <div
              class="iconfont icon-bg-previous flex items-center justify-center bg-[#072a2e] rounded-full w-40px h-40px cursor-pointer text-white mr-10px"
              @click="operate('slow')"
            ></div>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            :content="`${$t('播放')}`"
            placement="top"
            v-if="
              playStatus === 'pause' ||
                playStatus === 'init' ||
                !playStatus ||
                playStatus === 'finish'
            "
          >
            <div
              class="iconfont icon-bg-play  flex items-center justify-center w-40px bg-[#072a2e] rounded-full h-40px cursor-pointer text-white"
              @click="operate('play')"
            ></div>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            :content="`${$t('加载中')}`"
            placement="top"
            v-if="playStatus === 'pending' || playStatus === 'awaitData'"
          >
            <div
              class="iconfont el-icon-loading  flex items-center justify-center w-40px bg-[#072a2e] rounded-full h-40px cursor-pointer text-white"
            ></div>
          </el-tooltip>
          <el-tooltip
            v-if="playStatus === 'playing'"
            effect="dark"
            :content="`${$t('暂停')}`"
            placement="top"
          >
            <div
              class="iconfont icon-bg-pause flex items-center justify-center w-40px bg-[#072a2e] rounded-full h-40px cursor-pointer text-white"
              @click="operate('pause')"
            ></div>
          </el-tooltip>
          <el-tooltip effect="dark" :content="`${$t('快进')}`" placement="top">
            <div
              class="iconfont icon-bg-next flex items-center justify-center w-40px bg-[#072a2e] rounded-full h-40px cursor-pointer text-white ml-10px"
              @click="operate('fast')"
            ></div>
          </el-tooltip>
        </el-col>
      </el-row>
    </div>
  </CockpitCard>
</template>

<script>
import { find, fromPairs, get } from 'lodash'
import CockpitCard from '@/components/cockpit/CockpitCard'
import { ActivityApi } from '@wiz-api/haiguang'
import dayjs from 'dayjs'
import { createRequestQueue } from './js/groupRequest'

const activityApi = new ActivityApi()

export default {
  components: {
    CockpitCard,
  },
  props: {
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      /** 进度计划列表 */
      planList: [],
      /** 计划开始时间 */
      planStartDate: '',
      /** 计划结束时间 */
      planFinishDate: '',
      /** 查看时间 */
      checkDate: '',
      /** 加载跳转指定时间的状态 */
      loadProgress: false,
      changeTimeAble: true,
      playStatus: '',
      /** 速度 */
      speed: 1,
      taskList: [],
      currentDateStatistics: {},
      /** 请求参数列表 */
      requestParamList: [],
      /** 当前计划id */
      currentPlanId: '',
      /** 请求队列 */
      requestQueue: [],
      /** 进度条加载状态 */
      btnLoading: true,
      sliderData: 0,
      /** 当前时间 */
      currentDate: '',
    }
  },
  created() {
    // 获取计划列表
    this.requestQueue = createRequestQueue(10, this.cloudRender)
    this.getPlanList()
    // 并行请求
    this.cloudRender.Dispatch.on('Progress', this.dealProgress)
  },
  mounted() {},
  watch: {
    modelLoaded() {
      if (this.modelLoaded) {
      }
    },
  },
  computed: {
    // 时间允许选择范围
    datePickOption() {
      return {
        disabledDate: (time) => {
          if (this.planStartDate && this.planFinishDate) {
            return (
              time.getTime() < moment(this.planStartDate).valueOf() ||
              time.getTime() > moment(this.planFinishDate).valueOf()
            )
          }
          return true
        },
      }
    },
    // 进度条最大长度
    sliderMaxLenngth() {
      if (this.planStartDate && this.planFinishDate) {
        return dayjs(this.planFinishDate).diff(this.planStartDate, 'day')
      }
      return 1
    },
    /** 模型是否加载完成 */
    modelLoaded() {
      return this.customProps.loadModelStatus
    },
    progressMap() {
      const map = {
        workAsPlan: '#67c23a',
        workDelayPlan: '#9a32cd',
        workDelayDone: '#ffff00',
        delayPlanStart: '#f56c6c',
        noWork: '#ffffff',
        alreadyDone: '#1890ff',
        notInRange: '#ebeef5',
      }
      const configMap =
        fromPairs(
          get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit-tongre"].config')
            ?.progressMap
        ) || {}
      return { ...map, ...configMap }
    },
  },
  methods: {
    close() {},
    handleCheck() {},
    async getPlanList() {
      const [err, res] = await activityApi.planList()
      if (!err && res) {
        this.planList = res
      }
    },
    async changePlan(data) {
      await this.requestQueue.closeRequest()
      this.playStatus = ''
      this.sliderData = 0
      this.currentDate = ''
      this.checkDate = ''
      this.currentDateStatistics = {}
      this.btnLoading = true
      const currentPlan = find(this.planList, ['id', data])
      this.planStartDate = dayjs(currentPlan.startDate).format('YYYY-MM-DD')
      this.planFinishDate = dayjs(currentPlan.endDate).format('YYYY-MM-DD')
      this.currentPlanId = currentPlan.id
      // 开启进度模拟
      await this.cloudRender.Progress.create(
        this.planStartDate,
        this.planFinishDate,
        this.progressMap
      )
      this.btnLoading = false
      // 整理接口参数
      this.dealRequestParam(currentPlan.id)
    },
    operate(type) {
      switch (type) {
        case 'slow':
          if (this.speed !== 1) {
            this.speed--
            this.cloudRender.Progress.setSpeed(this.speed)
          }
          break
        case 'play':
          if (this.playStatus === 'pending' || !this.playStatus) {
            this.$message.warning('正在加载...')
            return
          }
          if (this.playStatus === 'finish') {
            this.cloudRender.Progress.jumpDate(this.planStartDate)
            return
          }
          this.playStatus = 'playing'
          this.cloudRender.Progress.startPlay()
          break
        case 'pause':
          this.cloudRender.Progress.pausePlay()
          break
        case 'fast':
          if (this.speed !== 7) {
            this.speed++
            this.cloudRender.Progress.setSpeed(this.speed)
          }
          break
        default:
          break
      }
    },
    dealRequestParam(planId) {
      this.requestParamList = []
      const daysNumber = dayjs(this.planFinishDate).diff(this.planStartDate, 'day')
      for (let i = 0; i <= daysNumber; i++) {
        const query = {
          planId,
          dateNow:
            i === 0
              ? undefined
              : dayjs(this.planStartDate)
                  .add(i - 1, 'day')
                  .format('YYYY-MM-DD'),
          dateChanged: dayjs(this.planStartDate)
            .add(i, 'day')
            .format('YYYY-MM-DD'),
        }
        this.requestQueue.add(async () => {
          return await activityApi.activityStatistics(query)
        }, query.dateChanged)
        this.requestParamList.push(query)
      }
    },
    sliderChanged(data) {
      // 快进or快退
      this.cloudRender.Progress.jumpDate(dayjs(this.planStartDate).add(data, 'day'))
    },

    /**
     * @description 跳转到固定日期，不向后再播放
     * @param {Number} days 距离计划开始时间天数
     */
    async playByCheckDate(days) {
      await this.cloudRender.Progress.jumpDate(dayjs(this.planStartDate).add(days, 'day'))
      this.cloudRender.Progress.pausePlay()
    },

    async dealProgress(data) {
      this.playStatus = data.status
      switch (data.status) {
        case 'pending':
          break
        case 'awaitData':
          // 请求分段数据
          this.requestQueue.stopRequest()
          await this.getPlanDataByRange(data.dateRange)
          this.requestQueue.restartRequest()

          break
        case 'pause':
          break
        case 'init':
          break
        case 'playing':
          this.currentDate = data.currentTime
          this.sliderData = dayjs(this.currentDate).diff(this.planStartDate, 'day')
          this.currentDateStatistics = this.requestQueue.getDataByDate(this.currentDate) ?? {}
          break
        default:
          break
      }
    },
    async getPlanDataByRange(dateRange) {
      const [err, res] = await activityApi.activityStatistics({
        planId: this.currentPlanId,
        dateNow: dateRange[0],
        dateChanged: dateRange[1],
      })
      if (!err && res) {
        await this.cloudRender.Progress.setDataByDateRange(dateRange[0], dateRange[1], {
          workAsPlan: res.workAsPlan,
          workDelayPlan: res.workDelayPlan,
          workDelayDone: res.workDelayDone,
          delayPlanStart: res.delayPlanStart,
          noWork: res.noWork,
          alreadyDone: res.alreadyDone,
          notInRange: res.notInRange,
        })
      }
    },
    /** 查看计划详情 */
    viewTaskDetail(taskId) {},
  },
  async beforeDestroy() {
    await this.requestQueue.closeRequest()
    this.cloudRender.Progress.destory()
    this.cloudRender.Dispatch.off('Progress', this.dealProgress)
  },
}
</script>

<style lang="scss" scoped>
.btn-example.el-button--primary.is-disabled {
  background: var(--cockpitTableHeaderTrBg) !important;
  background-blend-mode: var(--cockpitTableHeaderTrBgBlendMode);
  color: white !important;
}

::v-deep .el-slider__stop {
  position: absolute;
  height: 6px;
  width: var(--width);
  border-radius: 0;
  background-color: #15cea0;
  z-index: 2;
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
}
::v-deep.el-slider__runway {
  background-color: #134860 !important;
  height: 4px !important;
  margin: 5px 0 !important;
  .el-slider__button {
    width: 8px !important;
    height: 8px !important;
    border: 1px solid #03ffec !important;
  }
}
::v-deep .el-slider__bar {
  background-color: #03ffec !important;
  z-index: 5;
}
::v-deep.el-slider__button {
  border: 2px solid #409eff;
}
.max_label {
  background: url('../../../assets/images/progress/max_label.png');
  background-size: 100% 100%;
}
.min_label {
  background: url('../../../assets/images/progress/min_label.png');
  background-size: 100% 100%;
}
.card-box {
  background-image: unset !important;
}
::v-deep .visual_input.el-input.is-disabled .el-input__inner {
  background-color: transparent !important;
}
</style>
